/**
 * Единственное место, где записано, куда вложению обращения разрешено вести.
 *
 * Откуда список. Его владелец — прокси `edu-avatar-speech-recognition-proxy`:
 * `_resolve_allowed_hosts()` в `src/error_report/service.py` собирает allowlist
 * из `ERROR_REPORT_ALLOWED_HOSTS`, а без неё — из `S3_BUCKET`, и режет чужие
 * хосты и на submit репорта, и на кадре сообщения чата
 * (`enforce_attachment_limits` → `validate_storage_urls`). Клиент повторяет ту
 * же проверку сам: эта библиотека переиспользуется несколькими поверхностями
 * (модалка студента, кабинет дежурного, зеркала studcab), а превью вложения
 * проходит через `bypassSecurityTrustUrl` — снятую санитизацию Angular нельзя
 * подпирать одним лишь серверным allowlist.
 *
 * Почему хост без бакета. Yandex Object Storage адресует один и тот же бакет
 * двумя способами: virtual-hosted `https://<bucket>.storage.yandexcloud.net/<key>`
 * и path-style `https://storage.yandexcloud.net/<bucket>/<key>`; какой из них
 * вернёт presigned POST, зависит от SDK. Имя бакета зависит от окружения (прод —
 * `laba`, тестинг — свой бакет из Jenkins credentials) и клиенту неизвестно,
 * поэтому проверку бакета держит сервер, который один знает `S3_BUCKET`, а
 * клиент фиксирует хранилище и схему.
 *
 * Новый CDN. Добавить его хост одной строкой сюда И в `ERROR_REPORT_ALLOWED_HOSTS`
 * прокси. Списки не должны расходиться: хост только на прокси — вложение
 * дойдёт до чата и не отрисуется, хост только здесь — сервер откажет в отправке.
 */
export const REPORT_CHAT_ALLOWED_ATTACHMENT_HOSTS: readonly string[] = ['storage.yandexcloud.net'];

/**
 * Можно ли отдать этот URL в DOM (`<img [src]>`, `<a [href]>`, полноэкранное
 * превью) и отправить его на сервер.
 *
 * Отсекает `javascript:`, `data:`, `blob:` и прочие схемы (после
 * `bypassSecurityTrustUrl` их уже никто не поймает), `http:`, чужой хост,
 * подделку суффиксом `storage.yandexcloud.net.evil.tld` и userinfo-обманку
 * `https://storage.yandexcloud.net@evil.tld/x.png`.
 */
export function isAllowedAttachmentUrl(url: string | null | undefined): url is string {
  if (typeof url !== 'string' || !url) {
    return false;
  }
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:' || parsed.username || parsed.password) {
    return false;
  }
  const host = parsed.hostname.toLowerCase();
  return REPORT_CHAT_ALLOWED_ATTACHMENT_HOSTS.some(allowed => host === allowed || host.endsWith(`.${allowed}`));
}
